import { createFileRoute } from '@tanstack/react-router';
import { GeneralTab } from '@/features/account-settings/tabs/general';

export const Route = createFileRoute('/_authenticated/account-settings/general')({
    head: () => ({ meta: [{ title: 'General | promote.fun' }] }),
    component: GeneralTab,
});
